import { Directive, ElementRef, Renderer2 } from "@angular/core";

@Directive({
	selector: "[obgSensitiveData]",
})
export class SensitiveDataDirective {
	constructor(
		private element: ElementRef,
		private renderer: Renderer2
	) {
		this.renderer.setAttribute(this.element.nativeElement, "data-hj-suppress", "");
	}
}
